// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-074fe9f6]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.select-tip[data-v-074fe9f6] {\n  line-height: 40px;\n  height: 40px;\n  position: relative;\n}\n.notice[data-v-074fe9f6] {\n  line-height: 30px;\n  background: #FFFAD6;\n  color: #A05600;\n  padding: 10px;\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
